import { composeClassNames } from "@faedev/editor-utils";
import { useRouter } from "next/router";
import { Col, Row } from "react-bootstrap";
import Content from "src/components/Content";
import Footer from "src/components/Footer";
import Header from "src/components/Header";
import Headers from "src/components/Headers";
import Heading from "src/components/Heading";
import Page from "src/components/Page";
import Text from "src/components/Text";
import Translate from "src/components/Translate";
import VideoCard from "src/components/VideoCard";
import constants from "src/constants";
import PricesIntroCs from "src/content/PricesIntroCs";
import PricesIntroEn from "src/content/PricesIntroEn";
import PricesIntroSk from "src/content/PricesIntroSk";
import getDataClass from "src/functions/getDataClass";
import getDataSerie from "src/functions/getDataSerie";
import getDefaultOg from "src/functions/getDefaultOg";
import gutter from "src/functions/gutter";
import { mapContentToVideoCards } from "src/functions/mapContentToVideoCards";
import { sPagePrices } from "src/styles/sPagePrices.module.scss";

export default function Prices() {
  const { locale: lang } = useRouter();

  const series = constants.VideoCard.recommendedSeries;
  const serieSlug = series[Math.floor(Math.random() * series.length)];
  const serieData = getDataSerie(serieSlug, lang).data || [];
  const serieDataLoaded = serieData[0] === "success";

  const classes = constants.VideoCard.recommendedClasses;
  const classSlug = classes[Math.floor(Math.random() * series.length)];
  const classData = getDataClass(classSlug, lang).data || [];
  const classDataLoaded = classData[0] === "success";

  return (
    <>
      <Headers data={getDefaultOg(lang)} />
      <Page className={composeClassNames([sPagePrices, "page-prices"])}>
        <Header />
        <Content fluid={`xl`}>
          <Heading
            type={`h1`}
            title={
              <>
                <Translate tKey={`Flexible prices`} />
                <br />
                <Text size={`lg`} width={`semibold`}>
                  <Translate tKey={`according to your preferences`} />
                </Text>
              </>
            }
          />
          <Row>
            {(function () {
              switch (lang) {
                case `cs`:
                  return <PricesIntroCs />;
                case `sk`:
                  return <PricesIntroSk />;
                case `en`:
                  return <PricesIntroEn />;
              }
            })()}
            <Col xs={{ span: 12, order: 2 }} sm={6} lg={{ span: 4, order: 4 }}>
              {serieDataLoaded && serieData && (
                <>
                  <Heading
                    type={`h3`}
                    variant={`primary`}
                    title={<Translate tKey={`Selected serie for sale`} />}
                    style={gutter(`margin`, `vertical`, `xm`)}
                  />
                  <VideoCard
                    data={mapContentToVideoCards([serieData[1]])[0]}
                    type={`preview`}
                    size={`md`}
                    key={`video-card-serie`}
                  />
                </>
              )}
            </Col>
            <Col xs={{ span: 12, order: 4 }} sm={6} lg={{ span: 4, order: 5 }}>
              {classDataLoaded && classData && (
                <>
                  <Heading
                    type={`h3`}
                    variant={`primary`}
                    title={<Translate tKey={`Selected class for free`} />}
                    style={gutter(`margin`, `vertical`, `xm`)}
                  />
                  <VideoCard
                    data={mapContentToVideoCards([classData[1]])[0]}
                    type={`preview`}
                    size={`md`}
                    key={`video-card-serie`}
                  />
                </>
              )}
            </Col>
            {/*<Col xs={{ span: 12, order: 6 }} sm={6} lg={{ span: 4, order: 6 }}>
              <Heading
                type={`h3`}
                variant={`primary`}
                title={<Translate tKey={`I'm interested, let me know`} />}
                style={gutter(`margin`, `vertical`, `xm`)}
              />
              </Col>*/}
          </Row>
        </Content>
        <br />
        <br />
        <br />
        <Footer />
      </Page>
    </>
  );
}
